module.exports = __webpack_public_path__ + "static/media/features-home-main-image.453c61f4.svg";